import { type PlayerProfileResponse } from '@on3/api/src';
import { On3IconAthleteVerified, On3IconCircleCheck } from '@on3/icons/index';
import { PlayerTile } from '@on3/ui-lib/components/Player/PlayerTile';
import { On3Recruit } from '@on3/ui-lib/components/Svg';
import { recruitsSubConfig } from '@on3/ui-lib/utils/constants';
import { formatCurrency } from '@on3/ui-lib/utils/recurly';

import styles from './OrderSummary.module.scss';

interface RecruitsOrderSummaryProps {
  recruit?: Partial<PlayerProfileResponse>;
}

export const RecruitsOrderSummary = ({
  recruit,
}: RecruitsOrderSummaryProps) => {
  const { pricing } = recruitsSubConfig;

  return (
    <div className={styles.block}>
      <PlayerTile player={recruit} />
      <div className={styles.banner}>
        <On3Recruit isAlt />
        <div className={styles.pricing}>
          <span className={styles.original}>
            {formatCurrency(pricing.base)}
          </span>
          <span className={styles.current}>
            {formatCurrency(pricing.offer)}
          </span>
          <span className={styles.discount}>{pricing.discount} off</span>
        </div>
      </div>
      <ul className={styles.list}>
        <li>
          <span className={styles.verified}>
            <On3IconAthleteVerified />
            Verified Athlete
          </span>
          <On3IconCircleCheck className={styles.check} />
        </li>
        <li>
          Manage your Rivals Public Profile
          <On3IconCircleCheck className={styles.check} />
        </li>
        <li>
          Coaches and Scouts evaluate your profile
          <On3IconCircleCheck className={styles.check} />
        </li>
        <li>
          Access NIL Valuations
          <On3IconCircleCheck className={styles.check} />
        </li>
      </ul>
    </div>
  );
};
